/* lua.js generated code 0.3.0 */

require("clover/config/CloverConst")

// var ItemType;

// assert(!ItemType)
ItemType = table(
    [1, "INGAME_REFRESH", GamePropsType.kRefresh],
    [1, "INGAME_SWAP", GamePropsType.kSwap],
    [1, "ADD_FIVE_STEP", GamePropsType.kAdd5],
    [1, "INITIAL_2_SPECIAL_EFFECT", GamePropsType.kLine_Wrap_b],
    [1, "INITIAL_FOURTILE", GamePropsType.kFourTile_b],
    [1, "INGAME_HAMMER", GamePropsType.kHammer],
    [1, "SMALL_ENERGY_BOTTLE", GamePropsType.kEnergy1],
    [1, "MIDDLE_ENERGY_BOTTLE", GamePropsType.kEnergy2],
    [1, "LARGE_ENERGY_BOTTLE", GamePropsType.kEnergy3],
    [1, "ADD_THREE_STEP", GamePropsType.kAdd3_b],
    [1, "INFINITE_ENERGY_BOTTLE", GamePropsType.kEnergyInf],
    [1, "PVP_TICKET", GamePropsType.kPvpTicket],
    [1, "ENERGY_LIGHTNING", 4],
    [1, "COIN", 2],
    [1, "REOPEN_LADYBUG_TASK", 8],
    [1, "GOLD", 14],
    [1, "SHAKE_RESET_TIME", 15],
    [1, "HOURGLASS", 10029],
    [1, "GEM", 10],
    [1, "MOONCAKE", 11],
    [1, "MAYDAY_BOSS", 12],
    [1, "HOLYCUP", 11],
    [1, "THANKSGIVING_BOSS", 12],
    [1, "WEEKLY_RABBIT", 13],
    [1, "XMAS_BELL", 11],
    [1, "XMAS_BOSS", 12],
    [1, "ADD_TIME", 16],
    [1, "KEY_GOLD", 17],
    [1, "KWATER_MELON", 18],
    [1, "KELEPHANT", 19],
    [1, "WUKONG", 20],
    [1, "BLUE_STAR", 21],
    [1, "NewChestRedpack", 31],   // 星星抽奖红包
)
PrePropType = table(
    [1, "ADD_STEP", 1],
    [1, "REDUCE_TARGET", 2],
    [1, "TAKE_EFFECT_IN_BOARD", 3],
    [1, "ADD_TO_BAR", 4],
    [1, "ADD_SCORE", 5]
)
PrePropPriority = table(
    [1, GamePropsType.kLine_Wrap_b, 2],
    [1, GamePropsType.kLine_Wrap_b_t_limited, 2],
    [1, GamePropsType.kLine_Wrap_b_t_unlimited, 2],
    [1, GamePropsType.kLine_Wrap_b_t_cum_unlimited_min, 2],
    [1, GamePropsType.kAdPreBoom, 3],
    [1, GamePropsType.kAdPreLine, 4],
    [1, GamePropsType.kAdPreMagicBird, 1],
    [1, GamePropsType.kSuperBird_b, 1],
    [1, GamePropsType.kSuperBird_b_t_limited, 1],
    [1, GamePropsType.kSuperBird_b_t_unlimited, 1],
    [1, GamePropsType.kSuperBird_b_t_cum_unlimited_min, 1]
)
ItemNotInBag = table()
TimePropMap = table()
ItemType.getRealIdByTimePropId = function (propId) {
    var self = this
    assert(type(propId) === "number")
    if (TimePropMap[propId]) {
        return TimePropMap[propId]
    } else {
        return propId
    }
}
ItemType.isTimeProp = function (propId) {
    var self = this
    return TimePropMap[propId] != null
}
// 是否是关前道具
ItemType.isPreProp = function (propId) {
    let self = this
    if (ItemType.isPrePropSuperBird(propId) || ItemType.isPrePropAddStep(propId) || ItemType.isPrePropLineWrap(propId) || propId === GamePropsType.kAdd3_b || propId === GamePropsType.kAdd3_b_t_limited || propId === GamePropsType.kAdd3_b_t_unlimited || (propId >= GamePropsType.kAdd3_b_t_cum_unlimited_min && propId <= GamePropsType.kAdd3_b_t_cum_unlimited_max) || propId === GamePropsType.kLine_Wrap_b || propId === GamePropsType.kLine_Wrap_b_t_limited || propId === GamePropsType.kLine_Wrap_b_t_unlimited || (propId >= GamePropsType.kLine_Wrap_b_t_cum_unlimited_min && propId <= GamePropsType.kLine_Wrap_b_t_cum_unlimited_max) || propId === GamePropsType.kSuperBird_b || propId === GamePropsType.kSuperBird_b_t_limited || propId === GamePropsType.kSuperBird_b_t_unlimited || (propId >= GamePropsType.kSuperBird_b_t_cum_unlimited_min && propId <= GamePropsType.kSuperBird_b_t_cum_unlimited_max) || propId === GamePropsType.kMagicBird_b || propId === GamePropsType.kMagicBird_b_limited || (propId >= GamePropsType.kMagicBird_b_t_cum_unlimited_min && propId <= GamePropsType.kMagicBird_b_t_cum_unlimited_max) || (propId >= GamePropsType.kAdd3_b_t_cum_bind_level && propId <= GamePropsType.kAdPreMagicBird_b_t_cum_bind_level)) {
        return true
    }
    return false
}

// 是否是关前直线爆炸道具
// ItemType.isPrePropLineWrap = function (propId) {
//     let self = this
//     if (propId === GamePropsType.kLine_Wrap_b || propId === GamePropsType.kLine_Wrap_b_t_limited || propId === GamePropsType.kLine_Wrap_b_t_unlimited || propId === GamePropsType.kLine_Wrap_infinite) {
//         return true
//     }
//     return false
// }

// 是否是关前神奇鸟道具
ItemType.isPrePropSuperBird = function (propId) {
    let self = this
    if (propId === GamePropsType.kSuperBird_b || propId === GamePropsType.kSuperBird_b_t_limited || propId === GamePropsType.kSuperBird_b_t_unlimited || propId === GamePropsType.kSuperBird_infinite || propId === GamePropsType.kSuperBird_limited) {
        return true
    }
    return false
}
ItemType.isPrePropAddStep = function (propId) {
    var self = this
    if (propId === GamePropsType.kAdd3_b || propId === GamePropsType.kAdd3_b_t_limited || propId === GamePropsType.kAdPreAdd3 || propId === GamePropsType.kAdd3_b_t_unlimited || propId === GamePropsType.kAdd3_b_t_cum_unlimited_min || propId === GamePropsType.kAdd3_b_t_cum_bind_level || propId === GamePropsType.kAdd3_infinite || propId === GamePropsType.kAdd3_limited || propId === GamePropsType.kSalvageGiftAdd5) {
        return true
    }
    return false
}
ItemType.isPrePropReduceTarget = function (itemType) {
    var self = this
    return false
}
ItemType.isPassLevelPropLock = function (itemType, level) {
    var self = this
    return false
    // body
    if (itemType === GamePropsType.kSuperBird_b) {
        var score = UserManager.getInstance().getUserScore(level)
        if (score && score.star && score.star > 0) {
            return false
        } else {
            return true
        }
    }
    return false
}
// 需要两个格子的道具，爆炸直线特效
ItemType.isPrePropLineWrap = function (propId) {
    let self = this
    if (propId === GamePropsType.kLine_Wrap_b || propId === GamePropsType.kLine_Wrap_b_t_limited || propId === GamePropsType.kLine_Wrap_b_t_unlimited || propId === GamePropsType.kLine_Wrap_infinite || propId === GamePropsType.kLine_Wrap_b_t_cum_unlimited_min || propId === GamePropsType.kLine_Wrap_b_t_cum_bind_level || propId === GamePropsType.kLine_Wrap_limited) {
        return true
    }
    return false
}
// 只需要一个格子的道具
ItemType.isPrePropUseOneGrid = function (itemType) {
    let self = this
    if (ItemType.isPrePropSuperBird(propId) || itemType === GamePropsType.kFourTile_b || itemType === GamePropsType.kAdPreBoom || itemType === GamePropsType.kAdPreLine || itemType === GamePropsType.kAdPreMagicBird || itemType === GamePropsType.kSuperBird_b || itemType === GamePropsType.kSuperBird_b_t_limited || itemType === GamePropsType.kSuperBird_b_t_unlimited || itemType === GamePropsType.kSuperBird_b_t_cum_unlimited_min || itemType === GamePropsType.kMagicBird_b || itemType === GamePropsType.kMagicBird_b_limited || itemType === GamePropsType.kMagicBird_b_t_cum_unlimited_min || itemType === GamePropsType.kAdPreMagicBird_b_t_cum_bind_level) {
        return true
    }
    return false
}
ItemType.isPrePropTakeEffectInBoard = function (itemType) {
    var self = this
    if (ItemType.isPrePropSuperBird(itemType) || ItemType.isPrePropLineWrap(itemType) || itemType === GamePropsType.kLine_Wrap_b || itemType === GamePropsType.kLine_Wrap_b_t_limited || itemType === GamePropsType.kLine_Wrap_b_t_unlimited || itemType === GamePropsType.kLine_Wrap_b_t_cum_unlimited_min || itemType === GamePropsType.kFourTile_b || itemType === GamePropsType.kAdPreBoom || itemType === GamePropsType.kAdPreLine || itemType === GamePropsType.kAdPreMagicBird || itemType === GamePropsType.kSuperBird_b || itemType === GamePropsType.kSuperBird_b_t_limited || itemType === GamePropsType.kSuperBird_b_t_unlimited || itemType === GamePropsType.kSuperBird_b_t_cum_unlimited_min || itemType === GamePropsType.kMagicBird_b || itemType === GamePropsType.kMagicBird_b_limited || itemType === GamePropsType.kMagicBird_b_t_cum_unlimited_min || itemType === GamePropsType.kAdPreMagicBird_b_t_cum_bind_level || itemType === GamePropsType.kLine_Wrap_b_t_cum_bind_level) {
        return true
    }
    return false
}
ItemType.isPrePropAddToBar = function (itemType) {
    var self = this
    return true
}
ItemType.isPreAddScore = function (itemType) {
    var self = this
    if (itemType === GamePropsType.kComplementStar || itemType === GamePropsType.kComplementStar2) {
        return true
    }
    return false
}
ItemType.isSeasideStarDoubleProp = function (itemType) {
    var self = this
    if (itemType == GamePropsType.kSeasideStar_double_15 || itemType == GamePropsType.kSeasideStar_double_30) {
        return true
    }
    return false
}
ItemType.isLevelCollectDoubleProp = function (itemType) {
    var self = this
    if (itemType == GamePropsType.kLevelCollect_double_15 || itemType == GamePropsType.kLevelCollect_double_30) {
        return true
    }
    return false
}
ItemType.getPrePropType = function (itemType) {
    var self = this
    if (ItemType.isPrePropAddStep(itemType)) {
        return PrePropType.ADD_STEP
    } else if (ItemType.isPrePropReduceTarget(itemType)) {
        return PrePropType.REDUCE_TARGET
    } else if (ItemType.isPrePropTakeEffectInBoard(itemType)) {
        return PrePropType.TAKE_EFFECT_IN_BOARD
    } else if (ItemType.isPreAddScore(itemType)) {
        return PrePropType.ADD_SCORE
    } else {
        return PrePropType.ADD_TO_BAR
    }
}
ItemType.isItemNeedToBeAdd = function (itemId) {
    var self = this
    var itemType = Math.floor(itemId / 10000)
    if (itemType !== 1) {
        return false
    } // 非道具
    if (ItemNotInBag && ItemNotInBag[itemId]) { // 不需要加入背包
        return false
    }
    return true
}
ItemType.isStickerBattleProp = function (itemType) {
    var self = this
    if (itemType == GamePropsType.kStickerShine || itemType == GamePropsType.kStickerNormal) {
        return true
    }
    return false
}
module.exports = ItemType